import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { Route, Switch } from "wouter";
import { lazy, Suspense } from "react";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import Home from "./pages/Home";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import WebsiteTerms from "./pages/WebsiteTerms";

// Lazy load below-the-fold pages to reduce initial bundle
const Blog = lazy(() => import("./pages/Blog"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const LandingPage = lazy(() => import("./pages/LandingPage"));
const About = lazy(() => import("./pages/About"));

// Loading fallback
const PageLoader = () => <div style={{ minHeight: "100vh" }} />;

function Router() {
  // make sure to consider if you need authentication for certain routes
  return (
    <Suspense fallback={<PageLoader />}>
      <Switch>
        <Route path={"/"} component={Home} />
        <Route path={"/about"} component={About} />
        <Route path={"/blog"} component={Blog} />
        <Route path={"/privacy-policy"} component={PrivacyPolicy} />
        <Route path={"/website-terms"} component={WebsiteTerms} />
        {/* SEO Service Pages */}
        <Route path={"/bookkeeper-perth"} component={LandingPage} />
        <Route path={"/bookkeeping-services-perth"} component={LandingPage} />
        <Route path={"/bas-agent-perth"} component={LandingPage} />
        <Route path={"/xero-bookkeeper-perth"} component={LandingPage} />
        <Route path={"/payroll-bookkeeper-perth"} component={LandingPage} />
        <Route path={"/catch-up-bookkeeping-perth"} component={LandingPage} />
        <Route path={"/bookkeeping-for-tradies-perth"} component={LandingPage} />
        <Route path={"/bookkeeping-fees-perth"} component={LandingPage} />
        {/* Blog post route */}
        <Route path="/blog/:slug" component={BlogPost} />
        {/* 404 fallback */}
        <Route component={NotFound} />
      </Switch>
    </Suspense>
  );
}

// NOTE: About Theme
// - First choose a default theme according to your design style (dark or light bg), than change color palette in index.css
//   to keep consistent foreground/background color across components
// - If you want to make theme switchable, pass `switchable` ThemeProvider and use `useTheme` hook

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider
        defaultTheme="light"
        // switchable
      >
        <TooltipProvider>
          <Toaster />
          <Router />
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
